import React, { Component } from 'react'
import './HdblFilter.css'

class HdblFilter extends Component
{
    render() {
        return <div className={'hdblFilterContainer'}>
            <div className={'onoffswitch'}>
                <input type={'checkbox'} defaultChecked={this.props.currentState} key={this.props.currentState} className={'onoffswitch-checkbox'} id={'myonoffswitch'} ref={'hdblFilter'} onClick={()=>this.props.hdblFilterChange(this.refs.hdblFilter.checked)} />
                <label className="onoffswitch-label" htmlFor="myonoffswitch" />
            </div>
            <div><a href={'https://www.hdbl-herrsching.de'} target={'_blank'}><strong>Veranstaltungen aus dem Haus der bayerischen Landwirtschaft</strong></a></div>
        </div>
    }
}

export default HdblFilter




// WEBPACK FOOTER //
// ./src/components/HdblFilter.js